import { useProductsTFunction } from '@retail/products/i18n';
import { Table, TableContainer, TableHead, TableRow } from '@mui/material';
import { DocumentationTableBody } from './DocumentationTableBody';
import { StyledHeadTableCell } from '../styles';
import { EnvironmentDocumentationTableBody } from '../Environment/EnvironmentDocumentationTableBody';
import { MgItemDocumentation, Supplier } from '@retail/products/types';

interface Props {
  mgItemDocumentation: MgItemDocumentation;
}

export const DocumentationTable = ({ mgItemDocumentation }: Props) => {
  const t = useProductsTFunction();

  const suppliers: Supplier[] = mgItemDocumentation.mgSupplierItems.map((item) => item.supplier);

  return (
    <TableContainer sx={{ pb: 1 }}>
      <Table sx={{ gap: 2 }}>
        <TableHead>
          <TableRow>
            <StyledHeadTableCell
              sx={{ paddingLeft: (theme) => theme.spacing(6), textWrap: 'nowrap' }}
            >
              {t('products.mgItem.documentation.title')}
            </StyledHeadTableCell>

            {suppliers.map((supplier, index) => (
              <StyledHeadTableCell
                key={`${supplier.id}-row-${index}`}
                align="center"
                sx={{ textWrap: 'nowrap' }}
              >
                {supplier.name}
              </StyledHeadTableCell>
            ))}
          </TableRow>
        </TableHead>

        <DocumentationTableBody supplierItems={mgItemDocumentation.mgSupplierItems} />
        <TableHead>
          <TableRow>
            <StyledHeadTableCell sx={{ paddingLeft: (theme) => theme.spacing(6) }}>
              {t('products.mgItem.environmentDocumentation.title')}
            </StyledHeadTableCell>

            {suppliers.map((supplier, index) => (
              <StyledHeadTableCell key={`${supplier.id}-row-${index}`} align="center">
                {supplier.name}
              </StyledHeadTableCell>
            ))}
          </TableRow>
        </TableHead>

        <EnvironmentDocumentationTableBody supplierItems={mgItemDocumentation.mgSupplierItems} />
      </Table>
    </TableContainer>
  );
};
